import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"

import { ECoachingChatInputFormField } from "../types"

const resolver: ReturnType<typeof yupResolver> = yupResolver(
    yup.object().shape({
        [ECoachingChatInputFormField.ChatInput]: yup
            .string()
            .min(1)
            .max(5047)
            .matches(/^(?!\s*$)/)
            .required()
    })
)

export { resolver as coachingChatInputFormResolver }
